/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CouponObj model module.
 * @module model/CouponObj
 * @version v1
 */
class CouponObj {
    /**
     * Constructs a new <code>CouponObj</code>.
     * @alias module:model/CouponObj
     * @param coupon {Number} int64
     */
    constructor(coupon) { 
        
        CouponObj.initialize(this, coupon);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, coupon) { 
        obj['Coupon'] = coupon;
    }

    /**
     * Constructs a <code>CouponObj</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CouponObj} obj Optional instance to populate.
     * @return {module:model/CouponObj} The populated <code>CouponObj</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CouponObj();

            if (data.hasOwnProperty('Coupon')) {
                obj['Coupon'] = ApiClient.convertToType(data['Coupon'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CouponObj</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CouponObj</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CouponObj.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CouponObj.RequiredProperties = ["Coupon"];

/**
 * int64
 * @member {Number} Coupon
 */
CouponObj.prototype['Coupon'] = undefined;






export default CouponObj;

